/** Every word of the intake's company links (SA-1456 spec §7.5); the typeahead's own words are `companyText`. */

export const PICK_COMPANY = 'Pick a company…'
export const CHANGE_COMPANY = 'Change…'
export const CANCEL_PICK = 'Cancel'
export const LINK_FAILED = "Couldn't link the company"

/** The picker's label, and the accessible names that tell the two rows apart. */
export const pickerLabel = (field: string): string => `Company for ${field}`
export const pickFor = (field: string): string => `Pick a company for ${field}`
export const changeFor = (field: string): string => `Change the company for ${field}`
export const clearFor = (field: string): string => `Clear the company link for ${field}`
